















import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/store';

export default Vue.extend({
  name: 'Error',
  computed: mapState({
    defaultRoute: (state: any) => store.getters.getDefaultRoute
  }),
  methods: {
    toUrl(url: string) {
      if (url === 'refresh') {
        this.$router.push({
          path: this.defaultRoute,
          replace: true
        });
      } else if (url === 'check') {
        const origin = window.location.origin ? window.location.origin : window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        window.location.href = origin;
      }
    }
  },
  mounted() {
    console.log(404);
  }
});
